import axios from "axios";

export const LOCAL_PROXY_ORIGIN = "http://localhost:8080";

const useLocalProxy =
  import.meta.env.DEV && import.meta.env.VITE_USE_LOCAL_PROXY === "true";

const buildDownloadsBaseUrl = (url: string) =>
  url.replace(/\/output\/?$/, "/downloads/");

const removeDownloadPathPrefix = (fileId: string) =>
  fileId.replace(/^\/+/, "").replace(/^(downloads|output)\//, "");

export const API_BASE_URL = useLocalProxy
  ? `${LOCAL_PROXY_ORIGIN}/v2`
  : (import.meta.env.VITE_API_URL as string);
export const DOWNLOAD_BASE_URL = buildDownloadsBaseUrl(
  import.meta.env.VITE_DOWNLOAD_MOVEMENTS_URL as string,
);

export const configureAxiosBaseUrl = () => {
  axios.defaults.baseURL = API_BASE_URL;
};

export const buildMovementDownloadUrl = (fileId: string): string => {
  if (/^https?:\/\//.test(fileId)) {
    return fileId;
  }

  return `${DOWNLOAD_BASE_URL}${removeDownloadPathPrefix(fileId)}`;
};

export const normalizeDownloadUrl = (url: string): string => {
  return url;
};
